import React, {useEffect, useRef, useState} from "react";
import Video from "twilio-video";


const LocalParticipantView: React.FC<{ participant: Video.LocalParticipant }> = ({participant}) => {

    const [videoTracks, setVideoTracks] = useState<any>([]);
    const [audioTracks, setAudioTracks] = useState<any>([]);


    const videoRef: any = useRef();
    const audioRef: any = useRef();
    const canvasRef: any = useRef();


    const trackPubsToTracks = (trackMap: any) =>
        Array.from(trackMap.values())
            .map((publication: any) => publication.track)
            .filter((track) => track !== null);

    useEffect(() => {
        setVideoTracks(trackPubsToTracks(participant.videoTracks));
        setAudioTracks(trackPubsToTracks(participant.audioTracks));

        const trackSubscribed = (track: any) => {
            if (track.kind === "video") {
                setVideoTracks((videoTracks: any) => [...videoTracks, track]);
            } else if (track.kind === "audio") {
                setAudioTracks((audioTracks: any) => [...audioTracks, track]);
            }
        };

        const trackUnsubscribed = (track: any) => {
            if (track.kind === "video") {
                setVideoTracks((videoTracks: any) => videoTracks.filter((v: any) => v !== track));
            } else if (track.kind === "audio") {
                setAudioTracks((audioTracks: any) => audioTracks.filter((a: any) => a !== track));
            }
        };

        participant.on("trackSubscribed", trackSubscribed);
        participant.on("trackUnsubscribed", trackUnsubscribed);

        return () => {
            setVideoTracks([]);
            setAudioTracks([]);
            participant.removeAllListeners();
        };
    }, [participant]);

    useEffect(() => {
        const videoTrack = videoTracks[0];
        if (videoTrack) {
            videoTrack.attach(videoRef.current);
            videoRef.current.play();
            return () => {
                videoTrack.detach();
            };
        }
    }, [videoTracks]);

    useEffect(() => {
        const audioTrack = audioTracks[0];
        if (audioTrack) {
            audioTrack.attach(audioRef.current);
            return () => {
                audioTrack.detach();
            };
        }
    }, [audioTracks]);


    return (
        <>
            <canvas ref={canvasRef} style={{width: '100%', height: '100%', display: "none"}}></canvas>
            <div className="participant" style={{width:280}}>
                {/*<h3>{participant.identity}</h3>*/}
                <video controls style={{width:'100%'}}  ref={videoRef} autoPlay={true} />
                <audio ref={audioRef} autoPlay={true} muted={true}/>
            </div>
        </>
    );
};

export default LocalParticipantView;
